/**
 * Validation for decoration prices, mirroring the server DTO
 * (@IsNumber({ maxDecimalPlaces: 2 }), @Min(0), @Max) so a rejectable amount
 * is flagged in the field instead of failing the request with a generic 400.
 */

/** Upper bound of the DECIMAL(10,2) price columns. */
const MAX_PRICE = 99999999.99;

export function isValidPrice(value: number): boolean {
  return (
    Number.isFinite(value) &&
    value >= 0 &&
    value <= MAX_PRICE &&
    Math.round(value * 100) / 100 === value
  );
}
